<template>
    <div class="bg-white sm:rounded-lg sm:shadow-sm">
        <card-title v-if="title" :title="title" />
        <slot />
    </div>
</template>

<script setup lang="ts">
import CardTitle from '@/components/CardTitle.vue';
defineProps<{ title?: string }>();
</script>
